<script setup lang="ts">
import { computed, ref } from 'vue'
import BButton from '../common/bButton.vue'
import LogosGoogle from '~icons/logos/google'
import BModal from '@/components/common/BModal.vue'
import { userApi } from '@/services/api'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const props = defineProps<{
  search: string
}>()

const emits = defineEmits<{
  selectedImage: [image: string]
}>()

const images = ref([])

const imagesToArrayOfFour = computed(() => {
  return images.value.reduce((acc, curr, index) => {
    if (index % 4 === 0)
      acc.push([])
    acc[acc.length - 1].push(curr)
    return acc
  }, [])
})

const isOpen = ref(false)

const retreiveMaybeResourcePicture = () => {
  isOpen.value = true
  userApi.searchUserPicture({ name: props.search }).promise.then((res) => {
    images.value = res
  })
}
</script>

<template>
  <BButton bg="base" @click="retreiveMaybeResourcePicture">
    {{ t('common.importFromGoogle') }}
    <LogosGoogle class="translate-y-0.5" />
  </BButton>
  <BModal v-model="isOpen" class="max-w-2xl">
    <template #default>
      <div class="flex flex-wrap gap-4">
        <div v-for="groupImages in imagesToArrayOfFour" :key="groupImages" class="flex flex-col gap-4 w-48 grow">
          <div v-for="image in groupImages" :key="image" class="hover:scale-90 cursor-pointer transition-transform" @click="isOpen = false;emits('selectedImage', image)">
            <img
              class="h-auto w-full rounded-lg"
              :src="image" alt=""
            >
          </div>
        </div>
      </div>
    </template>
  </BModal>
</template>
